import React from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Button, Link, Tag } from './ui';

const StyledEbookCard = styled.article`
  border-radius: 30px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${standardColours.white};
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  flex-grow: 1;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.large`
    padding: 50px;
  `}
`;

const StyledTags = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 25px;
`;

const StyledHeading = styled.h3`
  ${fontSize(20)};
  margin-bottom: 20px;
  line-height: 1.4;
  color: ${brandColours.secondary};

  ${minBreakpointQuery.small`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(24)};
  `};
`;

const StyledText = styled.p`
  line-height: 1.6;
  margin-bottom: 20px;
`;

const StyledButton = styled(Button)`
  margin-top: auto;
`;

const EbookCard = ({ image, platforms, heading, summary, link }) => (
  <StyledEbookCard>
    <Link to={link.pageUrl}>
      <GatsbyImage image={image.gatsbyImageData} alt={image.alt} />
    </Link>
    <StyledContent>
      <StyledTags>
        {platforms.map(({ title }, id) => (
          <Tag key={id}>{title}</Tag>
        ))}
      </StyledTags>
      <StyledHeading>
        <Link to={link.pageUrl}>{heading}</Link>
      </StyledHeading>
      <StyledText>{summary}</StyledText>
      <StyledButton to={link.pageUrl} title={link.text}>
        Download now
      </StyledButton>
    </StyledContent>
  </StyledEbookCard>
);

export default EbookCard;

export const EbookCardFragment = graphql`
  fragment EbookCardFragment on DatoCmsEbook {
    featuredImage {
      gatsbyImageData(width: 710, height: 500)
      alt
    }
    platforms {
      title
      slug
    }
    title
    summary
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
  }
`;
